// extracted by mini-css-extract-plugin
export default {"container":"SubCategories_container__YlD-A","card":"SubCategories_card__lyma3","cardImg":"SubCategories_cardImg__V85gT"};